export default __webpack_public_path__ + "4b98b702a7b08faee82ddf7a828fb13e.png";